import { ContextAction } from '$ops-portal/context/global-context/types';
import type {
  CaseHistoryModalAction,
  CaseHistoryModalState
} from './caseHistory.types';

export const caseHistoryInitial: CaseHistoryModalState = { isModalOpen: false };

export const caseHistoryReducer = (
  state: CaseHistoryModalState,
  action: CaseHistoryModalAction
): CaseHistoryModalState => {
  switch (action.type) {
    case ContextAction.setCaseHistory:
      return { ...state, ...action.payload };
    case ContextAction.resetCaseHistory:
      return { ...state, isModalOpen: false };
    default:
      return state;
  }
};
